export const getElementType = (typename: string) => {
  switch (typename) {
    case 'MixedCollection':
      return 'collection'

    case 'AudioContent':
    case 'EventContent':
    case 'ImageContent':
    case 'LinkContent':
    case 'PdfContent':
    case 'QuizContent':
    case 'TextContent':
    case 'VideoContent':
      return 'content'

    default:
      return 'folder'
  }
}
